<template>
	<div :class="{ 'viewer-container': true }">
		<iframe :src="src" class="embed frame" :height="sizeHeight" v-if="viewType == 'path' || viewType == 'external'"></iframe>
		<div class="embed" v-if="viewType == 'embed'">
			<div v-html="embedMarkup"></div>
		</div>
	</div>
</template>
<script>
	import { ref, onMounted, computed } from "vue";
	import { resolveMclViewerUrl } from "@/services/utils/viewerUrl";
	export default {
		props: {
			uri: {
				type: String,
				default: ""
			},
			embed: {
				type: String,
				default: ""
			},
			viewType: {
				type: String,
				default: "false"
			},
			//sizeWidth: {
			//	type: String,
			//	default: ""
			//},
			sizeHeight: {
				type: String,
				default: ""
			}
		},
		setup(props) {
			const loading = ref(true);
			const domain = ref(process.env.VUE_APP_VIEWER_URI);

			const embedHtml = ref(props.embed);
			const parsedEmbed = () => {
				const template = document.createElement("template");
				template.innerHTML = embedHtml.value || "";
				return template;
			};
			const embedMarkup = computed(() => {
				const template = parsedEmbed();
				template.content.querySelectorAll("script").forEach((script) => script.remove());
				template.content.querySelectorAll("iframe[src]").forEach((frame) => {
					const source = frame.getAttribute("src");
					const resolved = resolveMclViewerUrl(source, domain.value);
					if (resolved !== source) frame.setAttribute("src", resolved);
				});
				return template.innerHTML;
			});

			const src = computed(() => {
				if (props.viewType === "external") {
					return resolveMclViewerUrl(props.uri, domain.value);
				} else {
					let relativePath = props.uri;
					if (props.uri.startsWith("/")) {
						relativePath = props.uri.substring(1);
					}
					return domain.value + relativePath;
				}
			});

			const LoadScript = (sourceScript) => {
				const src = sourceScript.getAttribute("src");
				if (!src) return Promise.resolve();

				const existing = Array.from(document.head.querySelectorAll("script[src]")).find(
					(script) => script.getAttribute("src") === src
				);
				if (existing) return Promise.resolve();

				const promise = new Promise((resolve, reject) => {
					const script = document.createElement("script");
					for (const attribute of sourceScript.attributes) {
						script.setAttribute(attribute.name, attribute.value);
					}
					script.onerror = () => {
						return reject(new Error(`Unable to load embedded script: ${src}`));
					};
					script.onload = () => {
						return resolve();
					};
					document.head.appendChild(script);
				});
				return promise;
			};

			const TryLoadScripts = () => {
				const scripts = parsedEmbed().content.querySelectorAll("script[src]");
				for (const script of scripts) {
					LoadScript(script).catch((err) => console.warn(err));
				}
			};

			onMounted(() => {
				TryLoadScripts();
			});

			return {
				loading,
				domain,
				src,
				embedMarkup
			};
		}
	};
</script>

<style lang="scss" scoped>
	.viewer-container {
		display: flex;
		width: 100%;
		overflow: hidden;

		&>.frame {
			flex-grow: 1;
			border: none;
			margin: 0;
			padding: 0;
		}
	}

	.page-height {
		height: calc(100vh - 250px);
	}
</style>
<style lang="scss" scoped>
	.viewer-container {
		& .embed {
			width: 100%;
		}
	}
</style>
